import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {InputFieldComponent} from './input-field/input-field.component';
import {GroupsFieldComponent} from './groups-field/groups-field.component';
import {AngularMultiSelectModule} from '../angular2-multiselect-dropdown/multiselect.component';
import {TextareaFieldComponent} from './textarea-field/textarea-field.component';
import {DatetimeFieldComponent} from './datetime-field/datetime-field.component';
import {DatetimeModule} from '../datetime/datetime.module';
import {AddressFieldComponent} from './address-field/address-field.component';
import {BooleanFieldComponent} from './boolean-field/boolean-field.component';
import {RoleFieldComponent} from './role-field/role-field.component';
import {PhoneFieldComponent} from './phone-field/phone-field.component';
import {SelectFieldComponent} from './select-field/select-field.component';
import {CarOwnerFieldComponent} from './car-owner-field/car-owner-field.component';
import {ResidentEmailFieldComponent} from './resident-email-field/resident-email-field.component';
import { ResidentAlternativeEmailsFieldComponent } from './resident-alternative-emails-field/resident-alternative-emails-field.component';
import {SwitchComponent} from './switch/switch.component';
import {ServiceRequestTypeFieldComponent} from './service-request-type-field/service-request-type-field.component';
import {AngularMaterialImportModule} from '../angular-material-import-module/angular-material-import.module';
import {MultiselectFieldComponent} from './multiselect-field/multiselect-field.component';
import {SettingsAmenityRestrictionsFieldComponent} from './settings-amenity-restrictions-field/settings-amenity-restrictions-field.component';
import {SettingsAmenityUsesFieldComponent} from './settings-amenity-uses-field/settings-amenity-uses-field.component';
import {SettingsAmenityPaymentsFieldComponent} from './settings-amenity-payments-field/settings-amenity-payments-field.component';
import {CommonComponentsModule} from '../../common-components.module';
import {MultiselectWithSelectFieldComponent} from './multiselect-with-select-field/multiselect-with-select-field.component';
import {CommonModule} from '@angular/common';
import {TextEditorFieldComponent} from './text-editor-field/text-editor-field.component';
import {DirectoryUnitArrayInputFieldComponent} from './directory-unit-array-input-field/directory-unit-array-input-field.component';
import {DateIntervalFieldComponent} from './date-interval-field/date-interval-field.component';
import {EmergencyContactsFieldComponent} from './emergency-contacts-field/emergency-contacts-field.component';
import {SearchSelectFieldComponent} from './search-select-field/search-select-field.component';
import {ListWithHintComponent} from '../list-with-hint/list-with-hint.component';
import { DateSelectFieldComponent } from './date-select-field/date-select-field.component';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AngularMultiSelectModule,
        DatetimeModule,
        AngularMaterialImportModule,
        CommonComponentsModule,
        UtilsModule
    ],
    declarations: [
        InputFieldComponent,
        GroupsFieldComponent,
        TextareaFieldComponent,
        DatetimeFieldComponent,
        BooleanFieldComponent,
        AddressFieldComponent,
        RoleFieldComponent,
        PhoneFieldComponent,
        SelectFieldComponent,
        CarOwnerFieldComponent,
        ResidentEmailFieldComponent,
        ResidentAlternativeEmailsFieldComponent,
        SwitchComponent,
        ServiceRequestTypeFieldComponent,
        MultiselectFieldComponent,
        SettingsAmenityRestrictionsFieldComponent,
        SettingsAmenityUsesFieldComponent,
        SettingsAmenityPaymentsFieldComponent,
        MultiselectWithSelectFieldComponent,
        TextEditorFieldComponent,
        DirectoryUnitArrayInputFieldComponent,
        DateIntervalFieldComponent,
        DateSelectFieldComponent,
        EmergencyContactsFieldComponent,
        SearchSelectFieldComponent,
        ListWithHintComponent
    ],
    exports: [
        InputFieldComponent,
        GroupsFieldComponent,
        TextareaFieldComponent,
        GroupsFieldComponent,
        DatetimeFieldComponent,
        BooleanFieldComponent,
        AddressFieldComponent,
        RoleFieldComponent,
        PhoneFieldComponent,
        SelectFieldComponent,
        CarOwnerFieldComponent,
        ResidentEmailFieldComponent,
        ResidentAlternativeEmailsFieldComponent,
        SwitchComponent,
        ServiceRequestTypeFieldComponent,
        MultiselectFieldComponent,
        SettingsAmenityRestrictionsFieldComponent,
        SettingsAmenityUsesFieldComponent,
        SettingsAmenityPaymentsFieldComponent,
        MultiselectWithSelectFieldComponent,
        TextEditorFieldComponent,
        DirectoryUnitArrayInputFieldComponent,
        DateIntervalFieldComponent,
        EmergencyContactsFieldComponent,
        SearchSelectFieldComponent,
        ListWithHintComponent,
        DateSelectFieldComponent
    ]
})
export class FieldsModule {
}



// WEBPACK FOOTER //
// /app/src/app/components/fields/fields.module.ts